import { z } from "zod";

export enum EPersonalizationSeverity {
  NORMAL = "NORMAL",
  NORMAL_LINK = "NORMAL_LINK",
  HIGH = "HIGH",
  HIGH_LINK = "HIGH_LINK",
  SITE_DEACTIVATION_WITH_TERMINATION = "SITE_DEACTIVATION_WITH_TERMINATION",
  DISABLE_LINK = "DISABLE_LINK",
  DISABLE_SITE_FOR_21_DAYS = "DISABLE_SITE_FOR_21_DAYS",
  SITE_DEACTIVATION = "SITE_DEACTIVATION",
}

export const personalizationSeveritySchema = z.nativeEnum(EPersonalizationSeverity);
